import { NotifyHelper } from "../../../helpers/toast";
import { eMonHocActionsObj } from "../../action-types/category/IMonHocActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const monHocActions = {
  ...generateActions(eMonHocActionsObj, "MON_HOC"),
  ...generateActionForKey(eMonHocActionsObj, "MON_HOC", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eMonHocActionsObj, "MON_HOC", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eMonHocActionsObj, "MON_HOC", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
  ...generateActionForKey(eMonHocActionsObj, "MON_HOC", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
